import { CarriersRepository } from '@/core/repositories/carriers.repository'
import {
    CarrierCreatePayloadT,
    CarrierTripartiteAgreementPayload,
    CarrierUpdatePayloadT,
    CarriersCreateCarrierResponseT,
    CarriersDownloadExcelPayloadT,
    CarriersDownloadExcelResponseT,
    CarriersGetCarrierResponseT,
    CarriersGetContractInfoResponseT,
    CarriersGetListResponseT,
    VehicleOwnerUpdateT,
} from '@/core/types/carriers.types'

const carriersRepository = new CarriersRepository()

export class CarriersService {
    async getList(params: any): Promise<CarriersGetListResponseT> {
        const response = await carriersRepository.getList(params)
        return response.data
    }

    async getCarrier(carrier_id: number): Promise<CarriersGetCarrierResponseT> {
        const response = await carriersRepository.getCarrier(carrier_id)
        return response.data
    }

    async getContractInformation(bin: string): Promise<CarriersGetContractInfoResponseT> {
        const response = await carriersRepository.getContractInformation(bin)
        return response.data
    }

    async createCarrier(
        carrier_payload: CarrierCreatePayloadT
    ): Promise<CarriersCreateCarrierResponseT> {
        const response = await carriersRepository.createCarrier(carrier_payload)
        return response.data
    }

    async updateCarrier(carrier_id: number, carrier_payload: CarrierUpdatePayloadT): Promise<void> {
        const response = await carriersRepository.updateCarrier(carrier_id, carrier_payload)
        return response.data
    }

    async updateVehicleOwner(vehicle_owner_payload: VehicleOwnerUpdateT): Promise<void> {
        const response = await carriersRepository.updateVehicleOwner(vehicle_owner_payload)
        return response.data
    }

    async resendTo1C(carrier_id: number): Promise<void> {
        const response = await carriersRepository.resendTo1C(carrier_id)
        return response.data
    }

    async addCarriersJira(): Promise<void> {
        await carriersRepository.addCarriersJira()
    }

    async exportExcel(
        params: CarriersDownloadExcelPayloadT
    ): Promise<CarriersDownloadExcelResponseT> {
        const response = await carriersRepository.exportExcel(params)
        return response.data
    }

    async tripartiteAgreement(payload: CarrierTripartiteAgreementPayload): Promise<void> {
        const response = await carriersRepository.tripartiteAgreement(payload)
        return response.data
    }
}
